// Fixes https://github.com/framer/motion/issues/2270
var getContextWindow=function getContextWindow(_ref){var current=_ref.current;return current?current.ownerDocument.defaultView:null;};export{getContextWindow};